export default {
  path: '/2019CqGarbageClassification',
  name: '2019CqGarbageClassification',
  component: () => import('./Home.vue'),
  redirect: '/2019CqGarbageClassification/introduction',
  meta: {
    title: '2019重庆垃圾分类',
  },
  children: [
    {
      path: 'introduction',
      component: () => import('./Introduction.vue'),
      name: 'introduction',
      meta: {
        title: '2019重庆垃圾分类',
      },
    },
    {
      path: 'news',
      component: () => import('./RelatedNews.vue'),
      name: 'RelatedNews',
      meta: {
        title: '2019重庆垃圾分类',
      },
    },
    {
      path: 'TableDownload',
      component: () => import('./TableDownload.vue'),
      name: 'TableDownload',
      meta: {
        title: '2019重庆垃圾分类',
      },
    },
  ],
};
